import { useState } from "react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react"; // Removed ComboboxOptions import as it's not needed now

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function CruiseShipDropdown({
  shipList,
  onCruiseShipChange,
  selectedShip,
  setSelectedShip,
  setCurrentPage,
}) {
  // If no ship is selected, default to "Select a ship"
  const selectedShipValue = selectedShip?.ship || "Select a ship"; // Default value when no ship is selected

  return (
    <div className="relative">
      <Combobox
        as="div"
        value={selectedShipValue} // Default value or selected ship
        onChange={(selectedValue) => {
          // If "Select a ship" is selected, we don't change anything
          if (selectedValue === "Select a ship") return;

          const selectedShipObject = shipList.find(
            (ship) => ship.ship === selectedValue
          );
          setSelectedShip(selectedShipObject); // Update selected ship
          setCurrentPage(1); // Reset to page 1
          onCruiseShipChange(selectedValue); // Notify the parent component
        }}
      >
        <Combobox.Label className="block text-base font-semibold leading-6 text-gray-900">
          Cruise Ship
        </Combobox.Label>
        <div className="relative mt-2 mb-4">
          <Combobox.Input
            className="mt-1 block w-full bg-white border border-gray-300 rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
            displayValue={(ship) => ship || selectedShipValue} // Display selected ship or default value
            readOnly={true} // Read-only input since we don't need to allow typing
            placeholder="Select a ship" // Placeholder text
          />
          <Combobox.Button className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none">
            <ChevronUpDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </Combobox.Button>

          {/* Only show dropdown options if there are ships */}
          <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {/* Add a default option to select "Select a ship" */}
            <Combobox.Option
              value="Select a ship"
              className={({ active }) =>
                classNames(
                  "relative cursor-default select-none py-2 pl-3 pr-9",
                  active ? "bg-indigo-600 text-white" : "text-gray-900"
                )
              }
            >
              {({ active, selected }) => (
                <>
                  <span
                    className={classNames(
                      "block truncate",
                      selected && "font-semibold"
                    )}
                  >
                    Select a ship
                  </span>

                  {selected && (
                    <span
                      className={classNames(
                        "absolute inset-y-0 right-0 flex items-center pr-4",
                        active ? "text-white" : "text-indigo-600"
                      )}
                    >
                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                    </span>
                  )}
                </>
              )}
            </Combobox.Option>

            {/* Display available ships */}
            {shipList.map((shipItem) => (
              <Combobox.Option
                key={shipItem.ship}
                value={shipItem.ship}
                className={({ active }) =>
                  classNames(
                    "relative cursor-default select-none py-2 pl-3 pr-9",
                    active ? "bg-indigo-600 text-white" : "text-gray-900"
                  )
                }
              >
                {({ active, selected }) => (
                  <>
                    <span
                      className={classNames(
                        "block truncate",
                        selected && "font-semibold"
                      )}
                    >
                      {shipItem.ship}
                    </span>

                    {selected && (
                      <span
                        className={classNames(
                          "absolute inset-y-0 right-0 flex items-center pr-4",
                          active ? "text-white" : "text-indigo-600"
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    )}
                  </>
                )}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </div>
      </Combobox>
    </div>
  );
}

export default CruiseShipDropdown;
